module.exports = [
	{
		"level": 8,
		"statement": "_____________ is putting a creative idea into action.",
		"responses": [
			{
				"label": "Business plan",
				"correct": false
			},
			{
				"label": "Strategy",
				"correct": false
			},
			{
				"label": "Innovation",
				"correct": true
			}
		]
	},
	{
		"level": 8,
		"statement": "The _____________ is a tool to analyze the present situation.",
		"responses": [
			{
				"label": "SWOT analysis",
				"correct": true
			},
			{
				"label": "entrepreneurial vision",
				"correct": false
			},
			{
				"label": "strategic planning",
				"correct": false
			}
		]
	},
	{
		"level": 8,
		"statement": "_____________, _____________, and _____________ are the basis of strategic direction.",
		"responses": [
			{
				"label": "Management, entrepreneurship, and marketing",
				"correct": false
			},
			{
				"label": "Mission, vision, and values",
				"correct": true
			},
			{
				"label": "Entrepreneurial vision, mission, and a business plan",
				"correct": false
			}
		]
	},
	{
		"level": 0,
		"statement": "How old are you? is a question about _____________.",
		"responses": [
			{
				"label": "name",
				"correct": false
			},
			{
				"label": "address",
				"correct": false
			},
			{
				"label": "age",
				"correct": true
			}
		]
	},
	{
		"level": 0,
		"statement": "Paul is _____________ architect.",
		"responses": [
			{
				"label": "a",
				"correct": false
			},
			{
				"label": "an",
				"correct": true
			},
			{
				"label": "Ø",
				"correct": false
			}
		]
	},
	{
		"level": 0,
		"statement": "Where do you live?",
		"responses": [
			{
				"label": "I am from Canada.",
				"correct": false
			},
			{
				"label": "She lives with her parents.",
				"correct": false
			},
			{
				"label": "I live on Berkley Road.",
				"correct": true
			}
		]
	},
	{
		"level": 0,
		"statement": "Who are they?",
		"responses": [
			{
				"label": "They are fine.",
				"correct": false
			},
			{
				"label": "Michael and Tom.",
				"correct": true
			},
			{
				"label": "My sister Laura.",
				"correct": false
			}
		]
	},
	{
		"level": 0,
		"statement": "Martin is _____________ engineer and his wife is _____________ architect.",
		"responses": [
			{
				"label": "an – an",
				"correct": true
			},
			{
				"label": "an – a",
				"correct": false
			},
			{
				"label": "a – an",
				"correct": false
			}
		]
	},
	{
		"level": 0,
		"statement": "Ashley is beautiful _____________ smart.",
		"responses": [
			{
				"label": "and",
				"correct": true
			},
			{
				"label": "but",
				"correct": false
			},
			{
				"label": "so",
				"correct": false
			}
		]
	},
	{
		"level": 0,
		"statement": "<strong>Rose</strong> – Where do you study English?<br/><strong>Lucas</strong> – I study English _____________ Wise Up.",
		"responses": [
			{
				"label": "in",
				"correct": false
			},
			{
				"label": "at",
				"correct": true
			},
			{
				"label": "on",
				"correct": false
			}
		]
	},
	{
		"level": 0,
		"statement": "The party is _____________ Friday _____________ the evening.",
		"responses": [
			{
				"label": "on – in",
				"correct": true
			},
			{
				"label": "in – at",
				"correct": false
			},
			{
				"label": "at – on",
				"correct": false
			}
		]
	},
	{
		"level": 0,
		"statement": "<strong>Abigail</strong> – _____________ do you have vacation?<br/><strong>Bruce</strong> – In January.",
		"responses": [
			{
				"label": "What",
				"correct": false
			},
			{
				"label": "Where",
				"correct": false
			},
			{
				"label": "When",
				"correct": true
			}
		]
	},
	{
		"level": 0,
		"statement": "Who is on the phone?",
		"responses": [
			{
				"label": "She is your sister.",
				"correct": false
			},
			{
				"label": "Your sister is here.",
				"correct": false
			},
			{
				"label": "It’s your sister.",
				"correct": true
			}
		]
	},
	{
		"level": 0,
		"statement": "How old are you? is a question about _____________.",
		"responses": [
			{
				"label": "name",
				"correct": false
			},
			{
				"label": "address",
				"correct": false
			},
			{
				"label": "age",
				"correct": true
			}
		]
	},
	{
		"level": 0,
		"statement": "Paul is _____________ architect.",
		"responses": [
			{
				"label": "a",
				"correct": false
			},
			{
				"label": "an",
				"correct": true
			},
			{
				"label": "Ø",
				"correct": false
			}
		]
	},
	{
		"level": 0,
		"statement": "Where do you live?",
		"responses": [
			{
				"label": "I am from Canada.",
				"correct": false
			},
			{
				"label": "She lives with her parents.",
				"correct": false
			},
			{
				"label": "I live on Berkley Road.",
				"correct": true
			}
		]
	},
	{
		"level": 0,
		"statement": "Who are they?",
		"responses": [
			{
				"label": "They are fine.",
				"correct": false
			},
			{
				"label": "Michael and Tom.",
				"correct": true
			},
			{
				"label": "My sister Laura.",
				"correct": false
			}
		]
	},
	{
		"level": 0,
		"statement": "Martin is _____________ engineer and his wife is _____________ architect.",
		"responses": [
			{
				"label": "an – an",
				"correct": true
			},
			{
				"label": "an – a",
				"correct": false
			},
			{
				"label": "a – an",
				"correct": false
			}
		]
	},
	{
		"level": 0,
		"statement": "Ashley is beautiful _____________ smart.",
		"responses": [
			{
				"label": "and",
				"correct": true
			},
			{
				"label": "but",
				"correct": false
			},
			{
				"label": "so",
				"correct": false
			}
		]
	},
	{
		"level": 0,
		"statement": "<strong>Rose</strong> – Where do you study English?<br/><strong>Lucas</strong> – I study English _____________ Wise Up.",
		"responses": [
			{
				"label": "in",
				"correct": false
			},
			{
				"label": "at",
				"correct": true
			},
			{
				"label": "on",
				"correct": false
			}
		]
	},
	{
		"level": 0,
		"statement": "The party is _____________ Friday _____________ the evening.",
		"responses": [
			{
				"label": "on – in",
				"correct": true
			},
			{
				"label": "in – at",
				"correct": false
			},
			{
				"label": "at – on",
				"correct": false
			}
		]
	},
	{
		"level": 0,
		"statement": "<strong>Abigail</strong> – _____________ do you have vacation?<br/><strong>Bruce</strong> – In January.",
		"responses": [
			{
				"label": "What",
				"correct": false
			},
			{
				"label": "Where",
				"correct": false
			},
			{
				"label": "When",
				"correct": true
			}
		]
	},
	{
		"level": 0,
		"statement": "Who is on the phone?",
		"responses": [
			{
				"label": "She is your sister.",
				"correct": false
			},
			{
				"label": "Your sister is here.",
				"correct": false
			},
			{
				"label": "It’s your sister.",
				"correct": true
			}
		]
	},
	{
		"level": 0,
		"statement": "How old are you? is a question about _____________.",
		"responses": [
			{
				"label": "name",
				"correct": false
			},
			{
				"label": "address",
				"correct": false
			},
			{
				"label": "age",
				"correct": true
			}
		]
	},
	{
		"level": 0,
		"statement": "Paul is _____________ architect.",
		"responses": [
			{
				"label": "a",
				"correct": false
			},
			{
				"label": "an",
				"correct": true
			},
			{
				"label": "Ø",
				"correct": false
			}
		]
	},
	{
		"level": 0,
		"statement": "Where do you live?",
		"responses": [
			{
				"label": "I am from Canada.",
				"correct": false
			},
			{
				"label": "She lives with her parents.",
				"correct": false
			},
			{
				"label": "I live on Berkley Road.",
				"correct": true
			}
		]
	},
	{
		"level": 0,
		"statement": "Who are they?",
		"responses": [
			{
				"label": "They are fine.",
				"correct": false
			},
			{
				"label": "Michael and Tom.",
				"correct": true
			},
			{
				"label": "My sister Laura.",
				"correct": false
			}
		]
	},
	{
		"level": 0,
		"statement": "Martin is _____________ engineer and his wife is _____________ architect.",
		"responses": [
			{
				"label": "an – an",
				"correct": true
			},
			{
				"label": "an – a",
				"correct": false
			},
			{
				"label": "a – an",
				"correct": false
			}
		]
	},
	{
		"level": 0,
		"statement": "Ashley is beautiful _____________ smart.",
		"responses": [
			{
				"label": "and",
				"correct": true
			},
			{
				"label": "but",
				"correct": false
			},
			{
				"label": "so",
				"correct": false
			}
		]
	},
	{
		"level": 0,
		"statement": "<strong>Rose</strong> – Where do you study English?<br/><strong>Lucas</strong> – I study English _____________ Wise Up.",
		"responses": [
			{
				"label": "in",
				"correct": false
			},
			{
				"label": "at",
				"correct": true
			},
			{
				"label": "on",
				"correct": false
			}
		]
	},
	{
		"level": 0,
		"statement": "The party is _____________ Friday _____________ the evening.",
		"responses": [
			{
				"label": "on – in",
				"correct": true
			},
			{
				"label": "in – at",
				"correct": false
			},
			{
				"label": "at – on",
				"correct": false
			}
		]
	},
	{
		"level": 0,
		"statement": "<strong>Abigail</strong> – _____________ do you have vacation?<br/><strong>Bruce</strong> – In January.",
		"responses": [
			{
				"label": "What",
				"correct": false
			},
			{
				"label": "Where",
				"correct": false
			},
			{
				"label": "When",
				"correct": true
			}
		]
	},
	{
		"level": 0,
		"statement": "Who is on the phone?",
		"responses": [
			{
				"label": "She is your sister.",
				"correct": false
			},
			{
				"label": "Your sister is here.",
				"correct": false
			},
			{
				"label": "It’s your sister.",
				"correct": true
			}
		]
	},
	{
		"level": 1,
		"statement": "Stacy _____________ the laundry every weekend.",
		"responses": [
			{
				"label": "does",
				"correct": true
			},
			{
				"label": "do",
				"correct": false
			},
			{
				"label": "is",
				"correct": false
			}
		]
	},
	{
		"level": 1,
		"statement": "Question: _________________________________________<br/>Answer: I have English classes on Mondays and Wednesdays.",
		"responses": [
			{
				"label": "Question: Where do you have English classes?",
				"correct": false
			},
			{
				"label": "Question: What time do you have English classes?",
				"correct": false
			},
			{
				"label": "Question: When do you have English classes?",
				"correct": true
			}
		]
	},
	{
		"level": 1,
		"statement": "Question: _________________________<br/>Answer: I have English classes every day.",
		"responses": [
			{
				"label": "Question: Where do you have English classes?",
				"correct": false
			},
			{
				"label": "Question: What time do you have English classes?",
				"correct": false
			},
			{
				"label": "Question: How often do you have English classes?",
				"correct": true
			}
		]
	},
	{
		"level": 1,
		"statement": "Pete is _____________ to go to the restroom.",
		"responses": [
			{
				"label": "dieng",
				"correct": false
			},
			{
				"label": "dying",
				"correct": true
			},
			{
				"label": "dieing",
				"correct": false
			}
		]
	},
	{
		"level": 1,
		"statement": "<strong>Claire</strong> – How do I get to the Central Park?<br/><strong>Jamie</strong> – _____________ this street, _____________ all the way down, and you’ll see it.",
		"responses": [
			{
				"label": "Take – go",
				"correct": true
			},
			{
				"label": "Turn – make",
				"correct": false
			},
			{
				"label": "Walk – get",
				"correct": false
			}
		]
	},
	{
		"level": 1,
		"statement": "It’s _____________ today. Are you going to _____________ party?",
		"responses": [
			{
				"label": "Kate birthday’s – your",
				"correct": false
			},
			{
				"label": "Kate’s birthday – her",
				"correct": true
			},
			{
				"label": "Kate birthday – the",
				"correct": false
			}
		]
	},
	{
		"level": 1,
		"statement": "<strong>Trevor<strong> – Is this _____________ purse?<br><strong>Mavis</strong> – No, my purse is brown.",
		"responses": [
			{
				"label": "my",
				"correct": false
			},
			{
				"label": "your",
				"correct": true
			},
			{
				"label": "his",
				"correct": false
			}
		]
	},
	{
		"level": 1,
		"statement": "It’s not that I don’t eat fish...I do, but I don’t like it _____________ much.",
		"responses": [
			{
				"label": "very",
				"correct": true
			},
			{
				"label": "a lot",
				"correct": false
			},
			{
				"label": "really",
				"correct": false
			}
		]
	},
	{
		"level": 1,
		"statement": "<strong>Helen</strong> – _____________ a swimming pool in the yard?<br/><strong>Jackie</strong> – No, but _____________ a nice barbecue area.",
		"responses": [
			{
				"label": "Are there / there is",
				"correct": false
			},
			{
				"label": "Is there – there is",
				"correct": true
			},
			{
				"label": "Is there – there are",
				"correct": false
			}
		]
	},
	{
		"level": 2,
		"statement": "We need some _____________ about the course.",
		"responses": [
			{
				"label": "information",
				"correct": true
			},
			{
				"label": "informations",
				"correct": false
			},
			{
				"label": "informationes",
				"correct": false
			}
		]
	},
	{
		"level": 2,
		"statement": "Last night, we _____________ a great movie.",
		"responses": [
			{
				"label": "did",
				"correct": false
			},
			{
				"label": "watched",
				"correct": true
			},
			{
				"label": "watch",
				"correct": false
			}
		]
	},
	{
		"level": 2,
		"statement": "Laura _____________ to Paris two years ago.",
		"responses": [
			{
				"label": "goed",
				"correct": false
			},
			{
				"label": "go",
				"correct": false
			},
			{
				"label": "went",
				"correct": true
			}
		]
	},
	{
		"level": 2,
		"statement": "<strong>Sarah</strong> – Do you want to go eat out tomorrow?<br/><strong>Felix</strong> – _____________ idea! I’d love to!",
		"responses": [
			{
				"label": "Awful",
				"correct": false
			},
			{
				"label": "Terrific",
				"correct": true
			},
			{
				"label": "Terrible",
				"correct": false
			}
		]
	},
	{
		"level": 2,
		"statement": "<strong>Paula</strong> – We could go to the movies tonight. What _____________?<br/><strong>Fabian</strong> – That sounds great!",
		"responses": [
			{
				"label": "do you think",
				"correct": true
			},
			{
				"label": "you think",
				"correct": false
			},
			{
				"label": "are you thinking",
				"correct": false
			}
		]
	},
	{
		"level": 2,
		"statement": "<strong>Serge</strong> – _____________ do I have to get the reports to you?<br/><strong>Marcy</strong> – As soon as possible, please.",
		"responses": [
			{
				"label": "Where",
				"correct": false
			},
			{
				"label": "When",
				"correct": true
			},
			{
				"label": "Why",
				"correct": false
			}
		]
	},
	{
		"level": 2,
		"statement": "<strong>Mariah</strong> – _____________ are you at home?<br/><strong>Sylvie</strong> – It’s a holiday here today.",
		"responses": [
			{
				"label": "Why",
				"correct": true
			},
			{
				"label": "What",
				"correct": false
			},
			{
				"label": "How",
				"correct": false
			}
		]
	},
	{
		"level": 3,
		"statement": "The sentence “You mustn’t cross when the light is red,” is _____________.",
		"responses": [
			{
				"label": "an obligation",
				"correct": false
			},
			{
				"label": "a prohibition",
				"correct": true
			},
			{
				"label": "a piece of advice",
				"correct": false
			}
		]
	},
	{
		"level": 3,
		"statement": "In the future, everything _____________ be different.",
		"responses": [
			{
				"label": "will",
				"correct": true
			},
			{
				"label": "while",
				"correct": false
			},
			{
				"label": "mustn’t",
				"correct": false
			}
		]
	},
	{
		"level": 3,
		"statement": "The sentence “We may have a problem” implies_____________.",
		"responses": [
			{
				"label": "permission",
				"correct": false
			},
			{
				"label": "probability",
				"correct": true
			},
			{
				"label": "advice",
				"correct": false
			}
		]
	},
	{
		"level": 3,
		"statement": "<strong>Maura</strong> – Danielle worked until 2 a.m. on this report yesterday…<br><strong>Claudia</strong> – Wow, she _____________ be exhausted!",
		"responses": [
			{
				"label": "should",
				"correct": false
			},
			{
				"label": "must",
				"correct": true
			},
			{
				"label": "mustn’t",
				"correct": false
			}
		]
	},
	{
		"level": 3,
		"statement": "I thought I could run the way I did _____________, but now I am totally worn out!",
		"responses": [
			{
				"label": "before",
				"correct": true
			},
			{
				"label": "after",
				"correct": false
			},
			{
				"label": "nowadays",
				"correct": false
			}
		]
	},
	{
		"level": 4,
		"statement": "I think English is _____________ than Portuguese.",
		"responses": [
			{
				"label": "the easiest",
				"correct": false
			},
			{
				"label": "as easy",
				"correct": false
			},
			{
				"label": "easier",
				"correct": true
			}
		]
	},
	{
		"level": 4,
		"statement": "Tommy is _____________ racer in the competition.",
		"responses": [
			{
				"label": "as fast as",
				"correct": false
			},
			{
				"label": "the fastest",
				"correct": true
			},
			{
				"label": "the faster",
				"correct": false
			}
		]
	},
	{
		"level": 4,
		"statement": "The sentence “Would you like some help?” expresses_____________.",
		"responses": [
			{
				"label": "a hypothesis",
				"correct": false
			},
			{
				"label": "an offer",
				"correct": true
			},
			{
				"label": "advice",
				"correct": false
			}
		]
	},
	{
		"level": 5,
		"statement": "I have studied English _____________ I was a kid.",
		"responses": [
			{
				"label": "for",
				"correct": false
			},
			{
				"label": "already",
				"correct": false
			},
			{
				"label": "since",
				"correct": true
			}
		]
	},
	{
		"level": 5,
		"statement": "It is important to quit _____________ before it’s a problem.",
		"responses": [
			{
				"label": "smoking",
				"correct": true
			},
			{
				"label": "to smoke",
				"correct": false
			},
			{
				"label": "smoking / to smoke",
				"correct": false
			}
		]
	},
	{
		"level": 5,
		"statement": "_____________ Anna _____________ Peter is coming because they are traveling.",
		"responses": [
			{
				"label": "Both / and",
				"correct": false
			},
			{
				"label": "Neither / nor",
				"correct": true
			},
			{
				"label": "Either / or",
				"correct": false
			}
		]
	},
	{
		"level": 6,
		"statement": "It was not my first time there. I _____________ the country before.",
		"responses": [
			{
				"label": "have been visiting",
				"correct": false
			},
			{
				"label": "had visited",
				"correct": true
			},
			{
				"label": "had been visiting",
				"correct": false
			}
		]
	},
	{
		"level": 6,
		"statement": "Where’s Owen? He’s never missed a class.",
		"responses": [
			{
				"label": "He must forget.",
				"correct": false
			},
			{
				"label": "He should have had a problem.",
				"correct": false
			},
			{
				"label": "Something must have happened.",
				"correct": true
			}
		]
	},
	{
		"level": 6,
		"statement": "We still need to decide _____________ to go out or stay home.",
		"responses": [
			{
				"label": "whether",
				"correct": true
			},
			{
				"label": "if",
				"correct": false
			},
			{
				"label": "unless",
				"correct": false
			}
		]
	},
	{
		"level": 7,
		"statement": "By the time I’m 40, _____________.",
		"responses": [
			{
				"label": "I should have gotten my master’s degree.",
				"correct": false
			},
			{
				"label": "I would have gotten my master’s degree.",
				"correct": false
			},
			{
				"label": "I will have gotten my master’s degree.",
				"correct": true
			}
		]
	},
	{
		"level": 7,
		"statement": "I really regret not having called Nick before he went back to New York. _____________",
		"responses": [
			{
				"label": "I should have called him.",
				"correct": true
			},
			{
				"label": "I would have called him.",
				"correct": false
			},
			{
				"label": "I must have called him.",
				"correct": false
			}
		]
	},
	{
		"level": 7,
		"statement": "“Mary told me to wait,” is the reported speech for:",
		"responses": [
			{
				"label": "Mary – Can you wait?",
				"correct": false
			},
			{
				"label": "Mary – Wait!",
				"correct": true
			},
			{
				"label": "Mary – Are you waiting?",
				"correct": false
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/questions-game-4.json
// module id = 670
// module chunks = 0